import {combineReducers} from 'redux'
import {combineForms} from 'react-redux-form'
import appReducer from './app/reducer'
import loginReducer from './login/reducer'
import searchReducer from './search/reducer'
import reportReducer from './report/reducer'
import refreshTokenReducer from './refresh-token/reducer'
import decisionTreeReducer from './decision-tree/reducer'
import monitoringReducer from './monitoring/reducer'
import modalReducer from './modal/reducer'
import analysisReducer from './analysis/reducer'
import translationsReducer from './monitoring-translations/reducer'

export default combineReducers({
  app: appReducer,
  login: loginReducer,
  report: reportReducer,
  refreshToken: refreshTokenReducer,
  decisionTree: decisionTreeReducer,
  monitoring: monitoringReducer,
  modal: modalReducer,
  analysis: analysisReducer,
  translations: translationsReducer,
  myForms: combineForms({
    search: searchReducer,
  }, 'myForms'),
})



// WEBPACK FOOTER //
// ./src/store/reducer.js